import React from "react";
import Button from "../FormElements/Button";
import IconPlus from "../../Resources/svg/Icons/IconPlus";
import Loading from "../loading";
import { CustomTable } from "../FormElements/CustomTable";
import IconDelete from "../../Resources/svg/Icons/IconDelete";
import IconEdit from "../../Resources/svg/Icons/IconEdit";
import { ButtonIcon } from "../FormElements/ButtonIcon";
import { CardTable } from "../FormElements/CardTable";

interface StepModalitiesProps {
  handleOpenModalAddModalities: () => void;
  modalities: any[];
  handleOpenModalEditModalitie: (modalitie: any) => void;
  deleteModalitie: (modalitie: any) => void;
  objSendForm: any;
  setObjSendForm: (data: any) => void;
  parients: any[];
  handleSubmitForm: (data: any) => void;
  loadingSubmit: boolean;
}

const StepModalities: React.FC<StepModalitiesProps> = ({
  handleOpenModalAddModalities,
  modalities,
  handleOpenModalEditModalitie,
  deleteModalitie,
  objSendForm,
  setObjSendForm,
  parients,
  handleSubmitForm,
  loadingSubmit,
}) => {
  return (
    <form
      style={{
        minHeight: "100%",
      }}
      className="flex col justify-between"
    >
      <div>
        <div className="flex just-end" style={{ marginBottom: "24px" }}>
          <ButtonIcon
            icon={<IconPlus />}
            text="Agregar Modalidad"
            onClick={handleOpenModalAddModalities}
          />
        </div>
        <div>
          <CustomTable
            headers={[
              { title: "NUM", width: 10 },
              { title: "MOD", width: 10 },
              { title: "GAR", width: 10 },              
              { title: "REAJUSTE", width: 10 },
              { title: "RENTA VITALICIA / DIFERIDO", width: 10 },
              { title: "MONEDA", width: 10 },
              { title: "ACCIONES", width: 80 },
            ]}
            data={modalities}
            renderItem={(modalitie: any) => (
              <React.Fragment key={modalitie.id}>
                <td> {modalitie.id}</td>
                <td> {modalitie.modalities}</td>
                <td>
                  {modalitie.guarYearsMod ? modalitie.guarYearsMod : "-"}
                </td>
                <td>
                  {modalitie.currencyMod ? modalitie.currencyMod : "-"}
                </td>
                <td>
                  {modalitie.defYearsMod ? modalitie.defYearsMod : "-"}
                </td>
                <td>
                  {modalitie.currencyMod ? modalitie.currencyMod : "-"}
                </td>
              </React.Fragment>
            )}
            actions={(modalitie) => (
              <div
                style={{ display: "flex", gap: "10px" }}
                key={modalitie.id}
              >
                <IconEdit
                  onClick={() => handleOpenModalEditModalitie(modalitie)}
                />
                <IconDelete onClick={() => deleteModalitie(modalitie)} />
              </div>
            )}
          />
          {modalities.map((modalitie: any) => (
            <CardTable key={modalitie.id}>
              <div className="card-table__box">
                <div className="flex">
                  <span className="card-table__description w-50">
                    Modalidad:
                  </span>
                  <span className="card-table__data">
                    {modalitie.modalities}
                  </span>
                </div>
                <div className="flex">
                  <span className="card-table__description  w-50">
                    RET:
                  </span>
                  <span className="card-table__data">
                    {modalitie.tempYearsMod ? modalitie.tempYearsMod : "-"}
                  </span>
                </div>
                <div className="flex">
                  <span className="card-table__description  w-50">
                    DIF:
                  </span>
                  <span className="card-table__data">
                    {modalitie.defYearsMod ? modalitie.defYearsMod : "-"}
                  </span>
                </div>
                <div className="flex">
                  <span className="card-table__description  w-50">
                    GAR:
                  </span>
                  <span className="card-table__data">
                    {modalitie.guarYearsMod ? modalitie.guarYearsMod : "-"}
                  </span>
                </div>
                <div className="flex">
                  <span className="card-table__description  w-50">
                    MONEDA:
                  </span>
                  <span className="card-table__data">
                    {modalitie.currencyMod ? modalitie.currencyMod : "-"}
                  </span>
                </div>
                <div
                  className="flex"
                  style={{
                    marginTop: "12px",
                    gap: "10px",
                    justifyContent: "flex-end",
                  }}
                >
                  <ButtonIcon
                    icon={<IconEdit />}
                    text="Editar"
                    onClick={() => handleOpenModalEditModalitie(modalitie)}
                  />
                  <ButtonIcon
                    icon={<IconDelete />}
                    text="Eliminar"
                    onClick={() => deleteModalitie(modalitie)}
                  />
                </div>
              </div>
            </CardTable>
          ))}
        </div>
      </div>
      <div className="button__container">
        <Button
          type="button"
          disabled={modalities.length <= 0 || loadingSubmit}
          onClick={() => {
            const test: any = {
              ...objSendForm,
              modalidades: modalities,
              grupoFamiliar: parients,
            };
            setObjSendForm({ ...test });
            handleSubmitForm(test);
          }}
        >
          Cotizar
        </Button>
      </div>
      {loadingSubmit && <Loading />}
    </form>
  );
};

export default StepModalities;
